// react
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'router';

// store
import { useLazyGetWebinarQuery } from 'store/api/cms';
import { Webinar as WebinarType } from '@karehero/models';

// components
import WebinarContentPage from '@karehero/llama/components/pages/WebinarContent/WebinarContent';

/**
 * WebinarContent shows the content of an Webinar from Sanity.
 */
export const WebinarContent = () => {
  // state
  const [webinar, setWebinar] = useState<WebinarType>();

  // hooks
  const { webinarId } = useParams();
  const [getWebinar, { isLoading: isWebinarLoading }] =
    useLazyGetWebinarQuery();
  const navigate = useNavigate();

  // effects
  useEffect(() => {
    if (!webinarId) {
      navigate(ROUTES.LIBRARY);
      return;
    }
    (async () => {
      const { data, error } = await getWebinar(webinarId);
      if (error) {
        navigate(ROUTES.LIBRARY);
        return;
      }
      data && setWebinar(data);
    })();
  }, [webinarId, getWebinar, navigate]);

  return (
    <WebinarContentPage
      content={webinar}
      isLoading={!webinar ? true : isWebinarLoading}
      navigate={navigate}
      backPath={ROUTES.WEBINAR}
    />
  );
};

export default WebinarContent;
